module.exports = __webpack_public_path__ + "static/media/logo138x75black.1469c452.png";